export default __webpack_public_path__ + "static/media/vector-arrow-select-1.83784de0.svg";